(function () {
  'use strict';

  // --- Surface Registry (2.1) ---
  var SURFACE_REGISTRY = {
    'pdp-offer-frame': {
      selector: '[data-rr-surface="pdp-offer-frame"]',
      maxDurationDays: 30
    },
    'pdp-bundle-pitch': {
      selector: '[data-rr-surface="pdp-bundle-pitch"]',
      maxDurationDays: 30
    },
    'pdp-cross-sell': {
      selector: '[data-rr-surface="pdp-cross-sell"]',
      maxDurationDays: 30
    },
    'pdp-size-fit-guide': {
      selector: '[data-rr-surface="pdp-size-fit-guide"]',
      maxDurationDays: 30
    },
    'cart-threshold-bar': {
      selector: '[data-rr-surface="cart-threshold-bar"]',
      maxDurationDays: 30
    },
    'cart-recommendations': {
      selector: '[data-rr-surface="cart-recommendations"]',
      maxDurationDays: 30
    },
    'collection-offer-banner': {
      selector: '[data-rr-surface="collection-offer-banner"]',
      maxDurationDays: 30
    }
  };

  // --- Cookie helpers (1.1) ---
  function getCookieValue(name) {
    var rawCookie = document.cookie || '';
    var cookies = rawCookie.split(';');
    for (var i = 0; i < cookies.length; i += 1) {
      var entry = cookies[i].trim();
      if (entry.indexOf(name + '=') !== 0) continue;
      try {
        return decodeURIComponent(entry.slice(name.length + 1));
      } catch (error) {
        return '';
      }
    }
    return '';
  }

  function setCookieValue(name, value, maxAge) {
    if (!name) return;
    var cookie = name + '=' + encodeURIComponent(value || '');
    cookie += '; path=/';
    if (typeof maxAge === 'number') {
      cookie += '; max-age=' + maxAge;
    }
    cookie += '; SameSite=Lax';
    if (window.location && window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  // --- Visitor ID (1.1) ---
  var VISITOR_COOKIE = 'rr_visitor_id';
  var VISITOR_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

  function generateUUID() {
    // Simple UUID v4 generator
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getOrCreateVisitorId() {
    var existing = getCookieValue(VISITOR_COOKIE);
    if (existing) return existing;
    var id = generateUUID();
    setCookieValue(VISITOR_COOKIE, id, VISITOR_COOKIE_MAX_AGE);
    return id;
  }

  // --- Deterministic hash (1.2) ---
  function hashString(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i += 1) {
      var ch = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + ch;
      hash = hash | 0; // Convert to 32-bit integer
    }
    return Math.abs(hash);
  }

  function assignVariant(experimentId, visitorId) {
    var bucket = hashString(experimentId + visitorId) % 2;
    return bucket === 0 ? 'control' : 'variant';
  }

  // --- Safety detection (4.1) ---
  function isPreviewMode() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode === true) return true;
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.has('preview_theme_id')) return true;
    } catch (e) {}
    return false;
  }

  // --- Kill switch (4.2) ---
  var KILL_SESSION_COOKIE = 'rr_exp_kill_session';

  function getKillState() {
    // Check URL param first
    var killParam = '';
    try {
      var params = new URLSearchParams(window.location.search);
      killParam = params.get('rr_exp_kill') || '';
    } catch (e) {}

    // If URL param present, store in session cookie
    if (killParam) {
      setCookieValue(KILL_SESSION_COOKIE, killParam);
    }

    // Read from session cookie (persists for session)
    var killValue = killParam || getCookieValue(KILL_SESSION_COOKIE);
    return killValue;
  }

  function isExperimentKilled(experimentId, killValue) {
    if (!killValue) return false;
    if (killValue === 'all') return true;
    return killValue === experimentId;
  }

  // --- Auto-expiry (4.3) ---
  function isExpired(expiresStr) {
    if (!expiresStr) return false;
    try {
      var expiresDate = new Date(expiresStr);
      return expiresDate.getTime() < Date.now();
    } catch (e) {
      return false;
    }
  }

  // --- Config reader (1.3) ---
  function readConfig() {
    var configEl = document.getElementById('rr-experiments-config');
    if (!configEl) return [];
    try {
      var parsed = JSON.parse(configEl.textContent || '{}');
      var experiments = parsed.experiments || [];
      if (!Array.isArray(experiments)) return [];
      // Validate each experiment
      return experiments.filter(function (exp) {
        return exp && exp.id && exp.surface && exp.selector && exp.status && exp.expires;
      });
    } catch (e) {
      console.warn('[RRExperiments] Failed to parse config:', e);
      return [];
    }
  }

  // --- Analytics (3.1, 3.2, 3.3) ---
  var viewedSet = Object.create(null); // in-memory dedupe
  var assignments = Object.create(null); // experimentId -> { variant, surface }

  function shouldSuppressEvents() {
    return isPreviewMode();
  }

  function trackExposure(experimentId, variant, surface) {
    if (shouldSuppressEvents()) return;
    if (viewedSet[experimentId]) return;
    viewedSet[experimentId] = true;

    var _learnq = window._learnq || [];
    _learnq.push(['track', 'Experiment Viewed', {
      experiment_id: experimentId,
      variant: variant,
      surface: surface,
      page_url: window.location.href
    }]);
  }

  function trackConversion(experimentId, conversionData) {
    if (shouldSuppressEvents()) return;

    var assignment = assignments[experimentId];
    if (!assignment) {
      console.warn('[RRExperiments] trackConversion: unknown experiment "' + experimentId + '"');
      return;
    }

    var _learnq = window._learnq || [];
    var eventData = {
      experiment_id: experimentId,
      variant: assignment.variant,
      surface: assignment.surface
    };

    if (conversionData && typeof conversionData === 'object') {
      var keys = Object.keys(conversionData);
      for (var i = 0; i < keys.length; i += 1) {
        eventData[keys[i]] = conversionData[keys[i]];
      }
    }

    _learnq.push(['track', 'Experiment Converted', eventData]);
  }

  // --- Anti-flicker reveal (1.5) ---
  function revealAll() {
    var els = document.querySelectorAll('[data-rr-experiment]');
    for (var i = 0; i < els.length; i += 1) {
      els[i].style.visibility = '';
    }
  }

  // --- Main processor (1.4) ---
  function processExperiments() {
    var safetyTimer = setTimeout(revealAll, 200);

    try {
      var experiments = readConfig();
      var visitorId = getOrCreateVisitorId();
      var preview = isPreviewMode();
      var killValue = getKillState();

      for (var i = 0; i < experiments.length; i += 1) {
        var exp = experiments[i];

        // Valid status values: 'active' (runs), 'draft' (never runs), 'shipped' (100% shipped, skip).
        // Non-active experiments are skipped: the element renders without any cohort CSS class.
        if (exp.status !== 'active') continue;

        // Auto-expiry (4.3)
        if (isExpired(exp.expires)) continue;

        // Registry validation (2.2)
        if (!SURFACE_REGISTRY[exp.surface]) {
          console.warn('[RRExperiments] Unknown surface "' + exp.surface + '" for experiment "' + exp.id + '"');
          continue;
        }

        // Determine variant
        var variant;
        if (preview || isExperimentKilled(exp.id, killValue)) {
          variant = 'control';
        } else {
          variant = assignVariant(exp.id, visitorId);
        }

        // Store assignment
        assignments[exp.id] = { variant: variant, surface: exp.surface };

        // Apply CSS class to matching element
        var el = document.querySelector(exp.selector);
        if (!el) continue;

        var className = 'rr-exp-' + exp.id + '--' + variant;
        el.classList.add(className);
        el.style.visibility = '';

        // Track exposure (only for active, non-killed, non-preview)
        if (!preview && !isExperimentKilled(exp.id, killValue)) {
          trackExposure(exp.id, variant, exp.surface);
        }
      }
    } catch (e) {
      console.error('[RRExperiments] Error:', e);
    }

    clearTimeout(safetyTimer);
    revealAll();
  }

  // --- Public API (3.2) ---
  window.RRExperiments = {
    trackConversion: trackConversion,
    getAssignment: function (experimentId) {
      var a = assignments[experimentId];
      return a ? a.variant : null;
    }
  };

  // --- Init ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processExperiments);
  } else {
    processExperiments();
  }
})();
